import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FlashMessagesService } from "angular2-flash-messages";
import { Router, ActivatedRoute } from '@angular/router';
import { ElementDef } from '@angular/core/src/view';
import { environment } from '../../../environments/environment';

export interface DialogData {
  userId: any;
}

@Component({
  selector: 'app-artworkfiles',
  templateUrl: './artworkfiles.component.html',
  styleUrls: ['./artworkfiles.component.css']
})
export class ArtworkfilesComponent implements OnInit {
  public invoiceFiles: Array<any> = [];
  public artworkFiles: Array<any> = [];
  public isArtworkFilesPresent: Array<any> = [];
  private cx: CanvasRenderingContext2D;
  public imageurl: string;
  public artworkColor: any = {};
  public artFileType:string='';
  @ViewChild("canvas") canvas;
  @ViewChild("downloadimage") canvasImage;
  //@ViewChild("downloadArtwork") downloadArtwork;
  //canvasEl: HTMLCanvasElement;

  constructor(
    public dialogRef: MatDialogRef<ArtworkfilesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService,
    private router: Router
  ) { }

  ngOnInit() {
    this.showArtworkFile();
    // this.displayCanvasImage("https://www.gstatic.com/webp/gallery3/1.png");
  }
  ngAfterViewInit() {

  }

  showArtworkFile = function () {
    this.clientOptions = {
      id: localStorage.getItem("userID"),
      user_id: this.data.userId
    };
    this.CommonService.apiService(
      "POST",
      "invoices/files",
      this.clientOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.invoiceFiles = response.data;
        }
      },
      err => {

        console.log(err);
      }
    );
  }

  backToArtworkData() {
    this.isArtworkFilesPresent = [];
    this.artworkFiles = [];
    this.displayCanvasImage("", 0, "","");
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  displayFolderData(artWorkFiles) {
    this.artworkFiles = artWorkFiles;
    this.isArtworkFilesPresent = Object.keys(artWorkFiles);

  }
  onNoClick() {
    this.dialogRef.close();
  }

  showInvoiceArtwork(imgName) {
    let imgExt = imgName.split(".").pop().toLowerCase();   
    if (['ai', 'eps', 'pdf','tiff','tif','zip','cdr','ps'].indexOf(imgExt) !== -1) {          
      return imgName='assets/img/'+imgExt+'.png';
    }
    else {      
      return imgName;     
    }

  }

  displayCanvasImage(url, index, location,orignalFileName) {    
    this.imageurl=environment.API_URL+'/file/download/'+btoa(url)+'/'+btoa(orignalFileName?orignalFileName:'');

    //url=this.artFileType==''?url:this.artFileType;  
    let urlExt = url.split(".").pop().toLowerCase();
    if (['ai', 'eps', 'pdf','tiff','tif','zip','cdr','ps'].indexOf(urlExt) !== -1) {          
      url='assets/img/'+urlExt+'.png';
    }
    else {   
      url
    }  
   
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    this.cx = canvasEl.getContext('2d');
    let image = new Image();
    image.src = url;
    canvasEl.width = 500;
    canvasEl.height = 480;
    let imageAspectRatio = image.width / image.height;
    let canvasAspectRatio = canvasEl.width / canvasEl.height;
    let renderableHeight = image.height;
    let renderableWidth = image.width;
    let xStart = (canvasEl.width - image.width) * 0.5;
    let yStart = (canvasEl.height - image.height) * 0.5;

    // If image's aspect ratio is greater than canvas's we fit on width
    // and place the image centrally along height
    if (image.width > canvasEl.width) {
      renderableWidth = canvasEl.width
      renderableHeight = image.height * (renderableWidth / image.width);
      xStart = 0;
      yStart = (canvasEl.height - renderableHeight) / 2;
    }
    if (image.height > canvasEl.height) {
      renderableHeight = canvasEl.height;
      renderableWidth = image.width * (renderableHeight / image.height);
      xStart = (canvasEl.width - renderableWidth) / 2;
      yStart = 0;
    }
    this.cx.drawImage(image, xStart, yStart, renderableWidth, renderableHeight);
    if (url != "") {
      this.artworkColor = this.artworkFiles[location][index].colors;
    }
  
    // this.imageurl = canvasEl.toDataURL("image/png")//"data:image/png;base64,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";
    //var dataURL = canvasEl.toDataURL();

  }

  downloadImage() {
    // this.downloadArtwork.nativeElement.href=this.canvasEl.toDataURL();
    //console.log("New Url",this.canvasEl.toDataURL());
    // const canvasElq: HTMLCanvasElement = this.canvas.nativeElement
    //var image = this.canvas.toDataURL();
    //console.log("image detail in canvas",image);
    //this.imageurl = canvasElq.toDataURL("image/png");
    //console.log("checkurl",this.imageurl);
    //"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACWCAYAAABkW7XSAAAEYklEQVR4Xu3UAQkAAAwCwdm/9HI83BLIOdw5AgQIRAQWySkmAQIEzmB5AgIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlACBB1YxAJfjJb2jAAAAAElFTkSuQmCC";
  };
  showMessage()
  {
    this._flashMessagesService.show("Please Select uploaded file for download", { cssClass: 'alert-danger', timeout: 3000 });
  }




}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/artworkfiles/artworkfiles.component.ts